import React from "react";

const ProjectRequisitionContext = React.createContext({});

export default ProjectRequisitionContext;
